/** @format */

import React from "react";

export default () => (
  <svg
    width="19"
    height="16"
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M19.0051 8.01472C19.0051 7.68981 18.8704 7.3782 18.6306 7.14844C18.3908 6.91869 18.0655 6.78962 17.7263 6.78962H4.52671L9.7241 2.1476C9.8974 2.00328 10.0269 1.81693 10.0991 1.6081C10.1713 1.39928 10.1835 1.17569 10.1343 0.960811C10.0849 0.746065 9.97615 0.548007 9.81934 0.38742C9.66254 0.226832 9.4635 0.109634 9.24313 0.0481248C9.02274 -0.0133711 8.78914 -0.0169035 8.56683 0.0378935C8.34452 0.0926906 8.14171 0.203798 7.97967 0.359559L0.40716 7.11776C0.278198 7.23209 0.175215 7.37066 0.104637 7.52482C0.0340591 7.67898 -0.00259962 7.84541 -0.00305176 8.01374C-0.00259962 8.18207 0.0340591 8.34851 0.104637 8.50266C0.175215 8.65682 0.278198 8.79539 0.40716 8.90973L7.97865 15.6699C8.22661 15.8914 8.55625 16.0095 8.89509 15.9983C9.23394 15.9871 9.55426 15.8474 9.78563 15.61C10.0169 15.3724 10.1402 15.0566 10.1285 14.732C10.1167 14.4074 9.97091 14.1006 9.72308 13.8789L4.52671 9.23983H17.7222C17.8905 9.24034 18.0572 9.20904 18.2129 9.1477C18.3685 9.08637 18.51 8.99621 18.6291 8.88239C18.7483 8.76858 18.8429 8.63335 18.9074 8.48446C18.9719 8.33557 19.0052 8.17594 19.0051 8.01472Z"
        fill="#191919"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="19" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
